import _ from 'lodash'
import io from 'socket.io-client'

const SOCKETHOST = process.env.VUE_APP_SOCKET_HOST || 'http://localhost/'
const SOCKETURL = process.env.VUE_APP_SOCKET_PATH || ':3001/socket/'
const REFRESHTIMER = 5000
const AWAITFORPOLLING = false

const nonReactiveObj = {
  socket: {},
}

export default {
  namespaced: true,
  state: {
    ready: false,
    subs: {},
    // screener: {},
    screenerEnabled: false,
    refreshIntervals: false,
  },
  mutations: {
    toggleSub(state, { toggle = 'set', ticker = 'UNDF' }) {
      if (!_.isString(toggle) || !_.isString(ticker)) {
        console.log('!!! Wrong mutation toggleSub')
        return
      }

      if (toggle === 'set') state.subs[ticker] = true
      else delete state.subs[ticker]
    },
    toggleScreener(state, toggle) {
      if (toggle) {
        state.screenerEnabled = true
      } else state.screenerEnabled = false
    },
    updateInterval(state, intervalId) {
      if (state.refreshInterval) {
        clearInterval(state.refreshInterval)
      }
      if (!_.isUndefined(intervalId)) {
        state.refreshInterval = intervalId
      }
    },
    updateReadiness(state, readyness) {
      state.ready = readyness
    },
    screenerTick() {}, // mutation just for subscribing
  },
  actions: {
    initSocketMarket(
      { commit, dispatch, rootState, state },
      { market = 'MOEX' }
    ) {
      if (!nonReactiveObj.socket) nonReactiveObj.socket = {}
      if (nonReactiveObj.socket[market]) nonReactiveObj.socket[market].close()
      nonReactiveObj.socket[market] = io(`${SOCKETHOST}${market}`, {
        path: `${SOCKETURL}MOEX`, // Now always MOEX due to no policy for load balancing
      })
      if (AWAITFORPOLLING)
        commit(
          'updateInterval',
          setInterval(() => {
            dispatch('refreshConnection')
          }, REFRESHTIMER)
        ) //  set new interval
      nonReactiveObj.socket[market].on('tick', (data) => {
        if (
          rootState.market.ticker !== data.ticker ||
          rootState.market.platform !== market ||
          state.screenerEnabled
        ) {
          // if screener showed up
          commit('screenerTick', {
            ...data,
            ticker: `${market}/${data.ticker}`,
          })
        } else {
          // normal usage
          commit(
            'market/updateDay',
            {
              ..._.omit(data, 'ticker'),
            },
            { root: true }
          )

          if (AWAITFORPOLLING)
            commit(
              'updateInterval',
              setInterval(() => {
                dispatch('refreshConnection')
              }, REFRESHTIMER)
            ) // reset interval and set new

          commit('market/updateCurrentPrice', _.get(data, 'c', 0), {
            root: true,
          })
          commit('market/recomputeMetrics', {}, { root: true })
        }
      })
      nonReactiveObj.socket[market].on('newsUpdate', (data) => {
        commit('news/updateNews', { news: data.news }, { root: true })
      })
      nonReactiveObj.socket[market].on('status_res', (data) => {
        console.log(data)
      })
    },
    init({ rootState, commit, dispatch }) {
      dispatch('initSocketMarket', { market: rootState.market.platform })
      commit('updateReadiness', true)
      console.log('Socket initialized')
    },
    refreshConnection({ state, rootState, dispatch }) {
      if (state.screenerEnabled) return
      console.log('Refresh socket connection')
      console.log(
        'rootState.market.ticker',
        rootState.market.ticker,
        rootState.market
      )
      dispatch('leave', { ticker: rootState.market.ticker })
      dispatch('subscribe', { ticker: rootState.market.ticker })
    },
    async subscribe(
      { dispatch, rootState, commit },
      { market, ticker, ticksOnly = false }
    ) {
      ticker = String(ticker).toUpperCase()
      if (!market) market = rootState.market.platform
      if (!nonReactiveObj.socket[market])
        await dispatch('initSocketMarket', { market: market })
      nonReactiveObj.socket[market].emit('join', {
        ticker: ticker,
        source: 'TICKS',
      })
      if (!ticksOnly)
        nonReactiveObj.socket[market].emit('join', {
          ticker: ticker,
          source: 'NEWS',
        })
      commit('toggleSub', { toggle: 'set', ticker })
    },
    async leave(
      { rootState, commit, dispatch },
      { market, ticker, ticksOnly = false }
    ) {
      ticker = String(ticker).toUpperCase()
      if (!market) market = rootState.market.platform
      if (!nonReactiveObj.socket[market])
        await dispatch('initSocketMarket', { market: market })
      nonReactiveObj.socket[market].emit('leave', {
        ticker: ticker,
        source: 'TICKS',
      })
      if (!ticksOnly)
        nonReactiveObj.socket[market].emit('leave', {
          ticker: ticker,
          source: 'NEWS',
        })
      commit('toggleSub', { toggle: 'unset', ticker })
    },
  },
}
